export const state = {
  enabled: true
};
export const mutations = {
  SET_ENABLED(state, enabled) {
    state.enabled = enabled;
  }
};
export const actions = {
  enableAds({ commit }) {
    commit("SET_ENABLED", true);
  },
  disableAds({ commit }) {
    commit("SET_ENABLED", false);
  }
};
export const getters = {
  adsEnabled: state => state.enabled
};
